import styled from 'styled-components';
import { isLogin } from '../../../utils/auth';
import { useNavigate } from 'react-router-dom';
import { useModal } from '../../../context/ModalContext';
import { useEffect, useState } from 'react';
import { MyPatternListProps } from '../../../interface/aiAnalyze/aiRecommend/type';
import AlgorithmService from '../../../service/auction/AlgorithmService';
import { SidoList } from '../../search/FilterData';

const imgMap: Record<string, string> = {
  아파트: 'main_building_40',
  상가: 'main_building_40',
  '다세대/빌라': 'main_home_40',
  대지: 'main_mountain_40',
};

const categoryList = [
  '아파트',
  '다세대/빌라',
  '상가',
  '다세대/빌라',
  '아파트',
  '아파트',
];

const subCategoryList = [
  '단기 투자',
  '유찰 2회 이상',
  '장기 투자',
  '유찰 3회 이상',
  '실거주',
  '실거주',
];

const descList = [
  '높은 단가, 활발한 거래\n단기 수익 실현의 기회',
  '인천은 2번만 유찰돼도\n입찰가가 절반',
  '현금 흐름이 필요하다면?\n상가 낙찰로 월세 수익',
  '높은 입찰가 부담이라면,\n지방 알짜 물건 탐색',
  '서울과 비슷한 환경,\n입찰가는 훨씬 저렴',
  '월세 수익 및 실거\n모두 가능한 오피스텔',
];
function Algorithm() {
  const navigate = useNavigate();
  const { modalDispatch } = useModal();

  const [recommendAlgorithmList, setRecommendAlgorithmList] = useState<
    MyPatternListProps[]
  >([]);

  // 기본 제공 알고리즘
  const fetchRecommendPatterns = async () => {
    try {
      const res = await AlgorithmService.getRecommendAlgorithmList(20, 1);

      setRecommendAlgorithmList(res.data || []);
    } catch (error: any) {
      console.error('[fetchRecommendPatterns 에러]', error);
      if (error.response) {
        console.error('[서버 응답 에러]', error.response.data);
      }
    }
  };

  useEffect(() => {
    fetchRecommendPatterns();
  }, []);

  return (
    <Section>
      <SectionTitle>AI 기반 실시간 경매 추천</SectionTitle>
      <List>
        {recommendAlgorithmList.map((item, idx) => (
          <Card
            key={item.algorithm_idx}
            onClick={() => {
              navigate('/AiRecommendation', {
                state: { isRecommend: true, selectedItem: item },
              });
            }}
          >
            <Icon
            // $color={item.iconColor}
            >
              <img
                src={`/assets/images/main/${imgMap[categoryList[idx]]}.svg`}
              />
            </Icon>

            <CardContent>
              <CardCategory>
                {SidoList.find((i) => i.code === item.pnu)?.region}・
                {categoryList[idx]}
              </CardCategory>
              <CardDescription>{descList[idx]}</CardDescription>
            </CardContent>

            <img src="/assets/images/arrow/arrow-right-gray-small.svg" alt="" />
          </Card>
        ))}
      </List>
    </Section>
  );
}

export default Algorithm;

const Section = styled.div`
  display: flex;
  padding: 24px 0 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

const SectionTitle = styled.div`
  color: rgba(0, 12, 30, 0.8);
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const List = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  overflow-x: auto;
  padding-right: 16px;
  align-self: stretch;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Card = styled.div`
  display: flex;
  flex: 0 0 248px;
  padding: 16px;
  align-items: center;
  gap: 8px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 10px 0 rgba(220, 228, 232, 0.3);
  user-select: none;
  align-self: stretch;
  &:active {
    background: rgba(2, 32, 71, 0.05);
  }
`;

const Icon = styled.div<{ $color?: string }>`
  display: flex;
  width: 38px;
  height: 38px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 999px;
  background-color: ${({ $color }) => $color};

  & > img {
    width: 24px;
    height: 24px;
  }
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`;

const CardCategory = styled.div`
  color: #6b7684;
  font-size: 12px;
  font-weight: 400;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const CardDescription = styled.div<{ $color?: string }>`
  color: rgba(0, 12, 30, 0.8);
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
  white-space: pre-line;

  span {
    color: ${({ $color }) => $color};
  }
`;
